import { Stack, Typography } from '@mui/material'
import { useRecoilValue } from 'recoil'
import { authenticatedUserAtom } from 'state'

const AcquisitionBanner = () => {
  const user = useRecoilValue(authenticatedUserAtom)

  const isJelledUser = user?.email?.endsWith('@jelled.io')
  const isInflectionUser = user?.email?.endsWith('@inflection.ai')

  // do not display banner for jelled.io / inflection.ai users
  if (isJelledUser || isInflectionUser) {
    return null
  }

  return (
    <Stack
      p="20px"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        width: '100%',
        background: '#E9F0FE',
      }}>
      <Typography variant="pS" textAlign="left">
        <b>Important Announcement:</b> JelledAI has been acquired by <a href="https://inflection.ai">Inflection AI</a>{' '}
        and will discontinue its services on <b>December 15, 2024</b>. Your account and data will be permanently deleted
        from our platform and refunds for the last month of payment will be issued. For questions, reach out to{' '}
        <a href="mailto:support@jelled.ai">support@jelled.ai</a>. Thank you for your support!
      </Typography>
    </Stack>
  )
}

export default AcquisitionBanner
